import { Headers } from '@egw/components'
import { SignInChallengeFail } from '@egw/features-auth'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const SignInChallengeFailurePage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.sign-in_challenge_fail.title')} />
      <SignInChallengeFail />
    </Layout>
  )
}
